import {
  CreateSignalOptions,
  Signal,
  WritableSignal,
  signal,
} from '@angular/core';
import { SignalGetter } from '@angular/core/primitives/signals';

export type ToggleableSignal = Signal<boolean> &
  WritableSignal<boolean> & {
    toggle(): void;
  };

export function toggleableSignal(
  initialValue: boolean,
  options?: CreateSignalOptions<boolean>
): ToggleableSignal {
  const internal = signal<boolean>(
    initialValue,
    options
  ) as SignalGetter<boolean> & WritableSignal<boolean>;

  return Object.assign(internal, {
    toggle: () => internal.update(x => !x),
  });
}
